import { createSelector } from '@reduxjs/toolkit'
import type { Workspace } from '@store/reducers/dashboard/types'

import { selectFolderId, selectWorkspaceId } from '../utils/selectIds'
import { selectDashboard } from './selectDashboard'

export const getTitle = createSelector(
  [selectDashboard, selectWorkspaceId, selectFolderId],
  (dashboard, workspaceId, folderId) => {
    const workspace: Workspace | null =
      dashboard.find((w) => w.id === workspaceId) ||
      dashboard.find((w) => w.type === 'personal') ||
      null

    if (folderId) {
      return workspace?.folders.find((f) => f.id === folderId)?.title
    }

    return workspace?.title
  }
)
